import { Module } from 'vuex';
import { actions } from '@/contract-management/store/contract-management.actions';
import { mutations } from '@/contract-management/store/contract-management.mutations';
import { RootState } from '@/store/store';
import { EnumDocumentType } from '@/enums/DocumentType';
import { ESortByType } from '@/enums/SortByType';
import { IContractManagementFilterRanges } from '@/contract-management/types/contract-management-filter-ranges';
import { IContractManagementKeyValues } from '@/contract-management/types/contract-management-key-values';
import { IDocument } from '@/types/Document';
import { IDocumentNotification } from '@/types/DocumentNotification';
import { IFolder } from '@/folders/types/folder';
import { IFolderTree } from '@/folders/types/folder-tree';
import { ISortOrder } from '@/types/SortOrder';
import { ITag } from '@/types/Tag';
import { getters } from '@/contract-management/store/contract-management.getters';
export const namespace = 'contractManagement';

export interface IContractManagementState {
  folderId: string;
  breadcrumb: IFolder[];
  documents: IDocument[];
  selectedDocumentIds: string[];
  error: string;
  filter: IContractManagementFilter;
  defaultFilter: IContractManagementFilter;
  filterActive: boolean;
  filterRanges: IContractManagementFilterRanges;
  folders: IFolder[];
  selectedFolder: IFolder;
  folderTree: IFolderTree;
  isLoadingDocuments: boolean;
  hasLoadedDocuments: boolean;
  keyValues: IContractManagementKeyValues;
  allTags: ITag[];
  filterInitialized: boolean;
  documentNotifications: IDocumentNotification[];
}

export interface IContractManagementFilter {
  search: string[];
  offset: number;
  limit: number;
  tags: ITag[];
  users: string[];
  value: number[];
  contractLength: number[];
  contractEndDate: string[];
  signDate: string[];
  documentType: EnumDocumentType;
  sortBy: ESortByType;
  sortOrder: ISortOrder;
}

export type IFilterSetting = Partial<IContractManagementFilter>;

export const defaultContractManagementFilter: IContractManagementFilter = {
  search: [],
  offset: 0,
  limit: 25,
  tags: [],
  users: [],
  value: [0, 0],
  contractLength: null,
  contractEndDate: [null, null],
  signDate: [null, null],
  documentType: EnumDocumentType.None,
  sortBy: ESortByType.SignDate,
  sortOrder: ISortOrder.Desc,
};

export const defaultFilterRanges: IContractManagementFilterRanges = {
  minValue: 0,
  maxValue: 10000,
  minContractLength: 0,
  maxContractLength: 5,
  minContractEndDate: null,
  maxContractEndDate: null,
};

export const state: IContractManagementState = {
  breadcrumb: [],
  documents: [],
  selectedDocumentIds: [],
  error: '',
  folderId: null,
  filter: defaultContractManagementFilter,
  defaultFilter: defaultContractManagementFilter,
  filterActive: false,
  filterRanges: defaultFilterRanges,
  folders: [],
  selectedFolder: null,
  folderTree: null,
  isLoadingDocuments: false,
  hasLoadedDocuments: false,
  allTags: [],
  keyValues: {
    sum: 0,
    count: 0,
    average: 0,
  },
  filterInitialized: false,
  documentNotifications: [],
};

const namespaced: boolean = true;

export const contractManagement: Module<IContractManagementState, RootState> = {
  getters,
  actions,
  namespaced,
  mutations,
  state,
};
